<div class="col-12 chromeless">
  @if (displayWidget != undefined) {
    <ng-template appWidgetsHost (onWidgetsLoaded)="onWidgetsLoaded($event)"
      widgetList="{{displayWidget}}"
      moduleName="Chromeless">
    </ng-template>
  }
</div>
